import classes from './ActionPanelFooter.module.css';

export function ActionPanelFooter({ children }: React.PropsWithChildren) {
  return <div className={classes.actionPanelFooter}>{children}</div>;
}
